import dayjs from 'dayjs'

import { useRouter } from 'vue-router'

import { showToast } from 'vant'

import account from '@/api/account'
import store from '@/api/store'
import setting from '@/api/setting'
import issue from '@/api/issue'

import { TimLogin } from '@/utils/tim'

import { useCommonStore, useAccountStore, useStoreStore } from '@/stores'

// 获取路由参数
export const getQueryParams = (key) => {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')

  let val =
    window.location.search.substring(1).match(reg) ||
    window.location.hash.substring(window.location.hash.search(/\?/) + 1).match(reg)

  if (val != null) {
    return decodeURIComponent(val[2])
  }
}

// 是否合作
export const isCooperation = (item) => {
  return item.to_store_id !== item.store_id && item.to_store_id !== ''
}

// 针对给定方案，判断当前店铺是否为甩单店铺
// 若当前店铺为甩单店铺，则仅有查看权限，无法对方案做操作
export const isFromStore = (store, item) => {
  return store.information.store_id !== item.to_store_id
}

// 针对给定方案，判断当前店铺是否为收单店铺
export const isToStore = (store, item) => {
  return store.information.store_id === item.to_store_id
}

// 是否已抢单
export const isProjectViewed = (account, item) => {
  return (
    (item.state === 0 || item.state === 1) &&
    item.staff_user_id !== '' &&
    item.staff_user_id !== account.information.user_id
  )
}

// 反转数组
export const reverseArray = (arr) => {
  // 新建的空数组是为了保存翻转后的数组
  let arrNew = []

  for (let i = 0; i < arr.length; i++) {
    // 利用unshift 将原数组重新插入newArray[]数组中
    arrNew.unshift(arr[i])
  }

  return arrNew
}

// 奖金排列
export const getBonusPermutation = (arr, num) => {
  let r = []
  ;(function f(t, a, n) {
    if (n === 0) return r.push(t)
    for (let i = 0, l = a.length; i <= l - n; i++) {
      // 取a数组的第一个值放入到t中，同时a数组删除取出来的那个值，余下的值用来遍历
      f(t.concat(a[i]), a.slice(i + 1), n - 1)
    }
  })([], arr, num)
  return r
}

// 判断是否复式
export const isNumberComplex = (val) => {
  if (val[0].length > 1 || val[1].length > 1 || val[2].length > 1) {
    return true
  }
}

// 比较对阵结果
export const compareSportsMatch = (a, b) => {
  return Number(a) - Number(b) > 0 ? '3' : Number(a) - Number(b) === 0 ? '1' : '0'
}

// 本地存储
export const setLocalStorage = (key, val) => {
  return new Promise((resolve, reject) => {
    try {
      localStorage.setItem(key, val)
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

// 初始化账户数据 TODO: 多请求 Promise 返回值
export const initAccountData = () => {
  const commonStore = useCommonStore()
  const accountStore = useAccountStore()
  const storeStore = useStoreStore()
  const router = useRouter()

  // 获取tencentIm 信息
  account
    .refreshToken()
    .then((res) => {
      accountStore.setTencentIm(res.results)
      setLocalStorage('ltu.token', res.results.token)
      TimLogin(res.results)
    })
    .catch(() => {})

  // 获取账户信息
  account
    .getInformation()
    .then((res) => {
      // 设置用户信息
      accountStore.setInformation(res.results.information)
      // 设置账本信息
      accountStore.setAccountBook(res.results.account_book)
      // 设置应用信息
      accountStore.setApplication(res.results.application)
      // 设置店铺公告
      accountStore.setStoreBulletin(res.results.store_bulletin)

      if (res.results.information.state === 0) {
        router
          .push({
            name: 'login-complete',
          })
          .catch(() => {})
      }
    })
    .catch(() => {})

  // 获取店铺信息
  store
    .getInformation()
    .then((res) => {
      // 设置店铺信息
      storeStore.setInformation(res.results.store)
      // 设置彩种配置
      storeStore.setLotterySetting(res.results.lottery_setting)
      // 设置支付通道
      storeStore.setPaymentChannel(res.results.payment_channel)
    })
    .catch(() => {})

  // 获取彩种信息
  setting
    .getLottery()
    .then((res) => {
      commonStore.setLottery(res.results)
    })
    .catch(() => {})

  // 获取3D省份信息
  issue
    .listSdArea()
    .then((res) => {
      commonStore.setArea(res.results)
    })
    .catch(() => {})
}

export const updateAccountInformation = () => {
  const accountStore = useAccountStore()

  // 获取账户信息
  account
    .getInformation()
    .then((res) => {
      // 设置用户信息
      accountStore.setInformation(res.results.information)
      // 设置账本信息
      accountStore.setAccountBook(res.results.account_book)
      // 设置应用信息
      accountStore.setApplication(res.results.application)
      // 设置店铺公告
      accountStore.setStoreBulletin(res.results.store_bulletin)
    })
    .catch(() => {})
}

export const updateStoreInformation = () => {
  const storeStore = useStoreStore()

  // 获取店铺信息
  store
    .getInformation()
    .then((res) => {
      // 设置店铺信息
      storeStore.setInformation(res.results.store)
      // 设置彩种配置
      storeStore.setLotterySetting(res.results.lottery_setting)
    })
    .catch(() => {})
}

// 校验场次
export const verifySelectedSportsMatch = (flag, obj) => {
  let temp = JSON.parse(obj)
  let l = flag ? temp.length - 1 : temp.length
  if (l >= 8) {
    return false
  }

  return true
}

// 获取比赛日期
export const getMatchDate = (val) => {
  if (!val) {
    return '--'
  }

  let d = dayjs(val).format('MM-DD')

  let dict = {
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六',
    0: '周日',
  }

  let w = dict[dayjs(val).day()]

  return `${d} ${w}`
}

// 获取奖期截止时间
export const getIssueEndTime = (time, format, type) => {
  const storeStore = useStoreStore()

  if (time === undefined || time === '') {
    return
  }

  let t = dayjs(time).subtract(storeStore.objLotterySetting[type].early_duration, 'minute')

  let weekday = t.day()
  let workingTime = storeStore.objWorkingTime[weekday]
  let d = t.format('YYYY-MM-DD')
  let end = dayjs(d + 'T' + workingTime.end + ':00+08:00')

  if (t.isBefore(end)) {
    return t.format(format)
  } else {
    return end.subtract(storeStore.objLotterySetting[type].early_duration, 'minute').format(format)
  }
}

export const checkSingleMatch = (obj) => {
  let label = {
    jczq: {
      0: '让球胜平负',
      1: '总进球',
      2: '比分',
      3: '半全场',
      4: '胜平负',
    },
    jclq: {
      0: '让分胜负',
      1: '胜负',
      2: '大小分',
      3: '胜分差',
    },
  }

  let flag = true
  obj.play_type.forEach((item) => {
    if (obj.support[item] === '0') {
      showToast('该场次比赛不支持' + label[obj.type][item] + '玩法单关！')
      flag = false
    } else if (obj.support[item] === '-1') {
      showToast('该场次比赛' + label[obj.type][item] + '玩法未开售！')
      flag = false
    }
  })

  return flag
}

export const checkJczqCount = (val) => {
  if (val.length > 8) {
    showToast('最多可投注8场比赛！')
    return false
  }
  return true
}

export const checkJclqCount = (val) => {
  let tempSelected = val.map((item) => {
    return item.obj_selected_value
  })

  let tempJSONStr = JSON.stringify(tempSelected)

  let f1 =
    tempJSONStr.match(/b_sfc_f[^;].*?}[,|}}]/g) !== null
      ? tempJSONStr
          .match(/b_sfc_f[^;].*?}[,|}}]/g)
          .join('')
          .indexOf('true')
      : []

  if (val.length > 4 && f1 > -1) {
    showToast('含胜分差不得超过4场！')
    return false
  }

  return true
}

// 获取组合，传递一组数据，计算这组数据的所有组合
export const getCombinations = (arr) => {
  let ret = []

  function get(arr, index, val) {
    if (!arr[index]) {
      ret.push(val)
      return
    }

    arr[index].forEach((v) => {
      get(arr, index + 1, index === 0 ? [v] : [...val, v])
    })
  }
  get(arr, 0)
  return ret
}

// 获取奖金组合，传递一组数据，计算不同组合下最大赔率与最小赔率的乘积
export const getBonusCombinations = (arr, num, fun) => {
  if (arr.length < num || num > 10) {
    return []
  }
  let variable = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
  ]
  let replaceStr = '#$#'
  let str =
    'var arr=arguments[0]; var fun=arguments[1];  var ret=[]; for (var a = 0; a < arr.length; a++) { ' +
    replaceStr +
    ' } return ret;'
  for (let i = 1; i < num; i++) {
    str = str.replace(
      replaceStr,
      ' for (var ' +
        variable[i] +
        ' =' +
        variable[i - 1] +
        '+ 1; ' +
        variable[i] +
        ' < arr.length; ' +
        variable[i] +
        '++) { ' +
        replaceStr +
        '  }'
    )
  }
  let temp = 'var temp= [];'
  for (let i = 0; i < num; i++) {
    temp += 'temp.push(arr[' + variable[i] + ']);'
  }
  if (fun) {
    temp += 'ret.push(fun(temp)); '
  } else {
    temp += 'ret.push(temp);'
  }
  str = str.replace(replaceStr, temp)

  return new Function(str).apply(null, [arr, fun])
}

// 获取内积之和
export const getScalarProductSum = (arr) => {
  let p = 1
  let sum = 0
  arr.forEach((x) => {
    x.forEach((y) => {
      p *= y
    })
    sum += p
    p = 1
  })
  return sum
}

// 二维数组去重
export const uniqueArray = (arr) => {
  const result = []

  for (let i = 0; i < arr.length; i++) {
    let isUnique = true

    for (let j = 0; j < result.length; j++) {
      if (arr[i].toString() === result[j].toString()) {
        isUnique = false
        break
      }
    }

    if (isUnique) {
      result.push(arr[i])
    }
  }

  return result
}

// 判断投注金额是否满足最低限额
export const isGtLimitMoney = (val, type) => {
  const storeStore = useStoreStore()

  return parseInt(val) >= Number(storeStore.objLotterySetting[type].limit_money)
}

// 判断余额是否充足
export const isBalanceEnough = (val) => {
  const accountStore = useAccountStore()

  return parseInt(val) <= Number(accountStore.objAccountBook.balance)
}

// 昵称含数字英文6个字符以上，替换为前2位 + ** + 最后2位
export const formatNacknameStr = (val) => {
  if (!val) return ''
  // 合法微信号正则
  const wxReg = /[a-zA-Z][a-zA-Z0-9_-]{5,19}/g

  return val.replace(wxReg, (match) => {
    const len = match.length
    // 计算中间起始位置
    const midIndex = Math.floor(len / 2) - 1
    // 前半段 + ** + 后半段（跳过中间两位）
    return match.slice(0, midIndex) + '**' + match.slice(midIndex + 2)
  })
}
